import http from '../utils/http';

const Knowledge = {
    /**
     * 分页获取知识图谱列表
     */
    getKnowledgeByPage(options = {}, config = {}) {
        return http.get('/knowledge/getKnowledgeByPage', options, {
            ...config
        })
    },
    /**
     * 新增知识图谱
     */
    addKnowledge(options = {}, config = {}) {
        return http.post('/knowledge/addKnowledge', options, {
            ...config
        })
    },

    /**
     * 修改知识图谱
     */
    updateKnowledge(options = {}, config = {}) {
        return http.post('/knowledge/updateKnowledge', options, {
            ...config
        })
    },
    /**
     * 启用/禁用知识图谱
     */
    stopStatus(options = {}, config = {}) {
        return http.post('/knowledge/stopStatus', options, {
            ...config
        })
    },

    /**
     * 删除知识图谱
     */
    deleteKnowledge(knowledgeId='') {
        return http.delete(`/knowledge/deleteKnowledge?knowledgeId=${knowledgeId}`)
    },
    /**
     * 文字转语音
     */
    textToMp3(options = {}, config = {}) {
        return http.post('/tts/textToMp3', options, {
            ...config
        })
    },
}

export default Knowledge;
